import Api from '../../../../../../shared/Api';
import { Promise } from 'es6-promise';
import { UserProfile } from './models/profile';

export type Language = {
    id: string;
    name: string;
};

export type TimeZone = {
    id: string;
    name: string;
};

export type ProfileData = {
    profile: {
        id: number;
        imageReference: string;
        username: string;
        identityServerId: number;
        name: string;
        firstname: string;
        lastname: string;
        email: string;
        phoneNumber: string;
        mobile: string;
        language: string;
        timeZoneId: string;
    };
    availableLanguages: Language[];
    timeZones: TimeZone[];
};

class ProfileApi {
    static load(): Promise<UserProfile> {
        return new Api().get('/me/profile');
    }

    static update(profile: UserProfile): Promise<UserProfile> {
        return new Api().put('/me/profile', profile);
    }

    static uploadProfileImage(image: any) {
        return new Api().postFiles('/me/profile/image', [image]);
    }
}

export default ProfileApi;
